<template>
  <div class="bg-white px-2 md:px-6 p-3 flex items-center">
    <div class="w-full flex items-center">
      <!-- Section gauche - Badge magasinier -->
      <div class="flex-1 flex items-center">
        <button-element v-if="route.name === 'category' || route.name === 'cart'" :label="'Retour aux catégories'"
          :icon="'pi pi-arrow-left'" :type="'button'" :severity="'blue'" :class="'mt-6'" @on-action="goBackToHome" />

        <div class="font-bold bg-brown text-white p-1 px-[30px] rounded-lg absolute -top-1">
          <div>Magasinier</div>
        </div>
      </div>

      <!-- Section centre - Logo -->
      <div class="flex-shrink-0 cursor-pointer" @click="router.push({ name: 'home' })">
        <img src="@/assets/img/logo_long.png" alt="selfmat" class="h-[60px]">
      </div>

      <!-- Section droite - Navigation et utilisateur -->
      <div class="flex-1 flex justify-end">
        <div v-if="$userStore.loggedUser"
          class="text-blue font-bold flex items-center relative border border-brown rounded-full pl-6 pr-6">
          <div class="flex items-center gap-4" @click="$event.stopPropagation()">
            <router-link to="/" class="text-brown hover:text-green font-medium flex items-center">
              <i class="pi pi-list mr-1"></i>
              Commandes
            </router-link>
            <router-link to="/categories" class="text-brown hover:text-green font-medium flex items-center">
              <i class="pi pi-box mr-1"></i>
              Catalogue
            </router-link>
          </div>

          <!-- Affichage de l'utilisateur sélectionné pour admin/storekeeper -->
          <div v-if="$userStore.selectedUserForShop" class="flex gap-2 items-center px-3 py-1 text-brown border-l ml-2">
            <div class="text-xs">
              <div class="font-bold">Client:</div>
              <div>{{ typeof $userStore.selectedUserForShop === 'object' ? $userStore.selectedUserForShop.email :
                $userStore.selectedUserForShop }}</div>
            </div>
            <button @click="changeUser" class="text-green hover:text-brown text-xs" title="Changer d'utilisateur">
              <i class="pi pi-refresh"></i>
            </button>
          </div>

          <div class="flex gap-2 items-center px-3 py-1 text-brown">
            <img v-if="$userStore.isProfessional && $userStore.loggedUser.company?.logo_url"
              :src="$userStore.loggedUser.company.logo_url" :alt="$userStore.loggedUser.company.name"
              class="h-[30px] rounded-full">
            <p>{{ $userStore.loggedUser.first_name }} {{ $userStore.loggedUser.company?.name }}</p>
          </div>
        </div>
        <button-element v-if="$userStore.loggedUser" :label="''" :icon="'pi pi-sign-out'" :type="'submit'"
          :severity="'brown'" class="!h-[45px] !w-[45px] !rounded-lg -ml-6" @on-action="logout"></button-element>
        <div v-else>
          <button-element :label="''" :icon="'pi pi-sign-in'" :type="'button'" :severity="'success'"
            class="!h-[45px] !w-[45px]" @on-action="goToLogin"></button-element>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ButtonElement from '@/components/atoms/ButtonElement.vue'
import { useUsers } from '@/features/users/controller'
const $userStore = useUsers()
import { useRoute } from 'vue-router'
const route = useRoute()

const logout = async () => {
  await $userStore.logoutAdmin()
}

const changeUser = () => {
  $userStore.selectedUserForShop = null
  router.push({ name: 'categories' })
}

import { useRouter } from 'vue-router'
const router = useRouter()
const goToLogin = () => {
  router.push({ name: 'login' })
}
function goBackToHome() {
  router.push({ name: 'categories' });
}
</script>